import React from 'react'

const Offers = () => {
  return (
    <div>
        <p>
          Your current plan does not support creating and managing offers and experiences via Crowdclass.
        </p>
        <h4>
          Reach out via e-mail to <span className="italized">hello@crowdclass.com</span> or via our chat to discuss with our team.
        </h4>
    </div>
  )
}

export default Offers